import { connect } from 'react-redux';
import { IS_SHOW_PRICING_POLL_SESSIONSTORAGE, onSubmit } from './events/onSubmit';
import { onSkip } from './events/onSkip';
import { IApplicationState } from '../../../../../../types/types';
import { Poll } from '../../../../base/components/Poll/components/Poll/Poll';
import { IPollEvents, IPollFields } from '../../../../base/components/Poll/components/Poll/types';
import { getUserPricingPoll } from '../../../../../../store/model/authUser/selectors/getUserPricingPoll';
import {
    CLASS_PRICING_POLL,
    PRICING_POLL_AFTER_TIME,
    PRICING_POLL_REVIEW_TITLE,
    PRICING_POLL_TITLE
} from './constants';
import { onAddOpinion } from './events/onAddOpinion';
import { getPricingPollDone } from './selectors/getPricingPollDone';
import { CLASS_POLL } from '../../../../base/components/Poll/components/constants';

const mapStateToProps = (
    state: IApplicationState,
): IPollFields => {
    const { lastTimeShowed, isShowed, isTriggered } = getUserPricingPoll(state);
    if (!isTriggered) return;

    let isShowedNow = sessionStorage.getItem(IS_SHOW_PRICING_POLL_SESSIONSTORAGE);
    isShowedNow = isShowedNow && JSON.parse(isShowedNow);
    if (!isShowedNow && isShowed) return;

    let isShow = null;

    const isTrialExtendOpen = !!document.querySelector('.dialog-blocker__trial-dialog');
    let isAnotherPoll = false;
    const anotherPoll = document.querySelector(`.${CLASS_POLL}`) as HTMLElement;
    if (anotherPoll) {
        isAnotherPoll = !anotherPoll.parentElement.className.includes('poll-placeholder--pricing');
    }
    isShow = !isAnotherPoll && !isTrialExtendOpen
    if (!isShow) return { isShow };

    isShow = !lastTimeShowed;

    if (lastTimeShowed) {
        const timeSinceLastShowed = Date.now() - lastTimeShowed;
        if (timeSinceLastShowed < PRICING_POLL_AFTER_TIME) { // только что ответил, показать Done
            isShow = true;
        }
    }

    return {
        doneText: getPricingPollDone(),
        isHideOnCancel: true,
        isHideOnDone: false,
        isShow,
        className: CLASS_PRICING_POLL,
        title: PRICING_POLL_TITLE,
        reviewTitle: PRICING_POLL_REVIEW_TITLE,
        // questionsList: [{ question: '', isChips: true, options: PRICING_POLL_OPTIONS }],
    };
}

const mapDispatchToProps = (
    dispatch: any,
): IPollEvents => {
    return {
        onAddOpinion: () => dispatch(onAddOpinion()),
        onSkip: () => dispatch(onSkip()),
        onSubmit: (results) => dispatch(onSubmit(results))
    };
}

export const PricingPollHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Poll);

PricingPollHOC.displayName = 'PricingPollHOC';
